/**
 * @Description: 目标行业/类别信息的多语言文言内容相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  IndustryAndCategoryLanguageModel,
  IndustryAndCategoryLanguageSearchModel,
  IndustryAndCategoryLanguagePageSearchModel,
  IndustryAndCategoryLanguageAddModel,
  IndustryAndCategoryLanguageUpdateModel,
  IdsModel
} from '@/model/product/IndustryAndCategoryLanguageModel'

const baseUrl = Route.product + '/industryAndCategoryLanguage'

/**
 * 搜索分页数据
 */
export const pageSearchIndustryAndCategoryLanguage = (param: IndustryAndCategoryLanguagePageSearchModel) => {
  return https().request<RootObject<PageRespModel<IndustryAndCategoryLanguageModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchIndustryAndCategoryLanguage = (param: IndustryAndCategoryLanguageSearchModel) => {
  return https().request<RootObject<IndustryAndCategoryLanguageModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getIndustryAndCategoryLanguage = (id: number) => {
  return https().request<RootObject<IndustryAndCategoryLanguageModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addIndustryAndCategoryLanguage = (param: IndustryAndCategoryLanguageAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateIndustryAndCategoryLanguage = (param: IndustryAndCategoryLanguageUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeIndustryAndCategoryLanguage = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveIndustryAndCategoryLanguage = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
